/* One shared interaction layer for the local homepage and all product previews. */
(()=>{
 const header=document.querySelector('header'),nav=header?.querySelector('nav');if(!nav)return;
 const items=[...nav.querySelectorAll('.nav-item')],mobile=header.querySelector('.mobile-toggle');
 const desktop=matchMedia('(min-width:1000px)');let timer;
 function close(){clearTimeout(timer);document.body.classList.remove('menu-open');items.forEach(item=>{item.querySelector('.mega-menu').hidden=true;item.querySelectorAll('[aria-expanded]').forEach(el=>el.setAttribute('aria-expanded','false'));item.querySelector('.nav-expand span').textContent='+'})}
 function open(item){close();document.body.classList.add('menu-open');item.querySelector('.mega-menu').hidden=false;item.querySelectorAll('[aria-expanded]').forEach(el=>el.setAttribute('aria-expanded','true'));item.querySelector('.nav-expand span').textContent='−'}
 function setMobile(isOpen){
  const wrapper=header.parentElement;
  if(isOpen)wrapper.style.height=`${(header.querySelector('.dd-offer-strip,.announcement')?.offsetHeight||0)+(header.querySelector('.utility')?.offsetHeight||0)}px`;
  else wrapper.style.removeProperty('height');
  nav.classList.toggle('open',isOpen);document.body.classList.toggle('mobile-menu-visible',isOpen);
  mobile.setAttribute('aria-expanded',String(isOpen));mobile.setAttribute('aria-label',isOpen?'Close menu':'Open menu');mobile.textContent=isOpen?'×':'☰';
 }
 function closeMobile(){setMobile(false);close()}
 items.forEach(item=>{
  const anchor=item.querySelector('.nav-trigger'),button=item.querySelector('.nav-expand');
  item.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&desktop.matches)open(item)});
  item.addEventListener('pointerleave',()=>{if(desktop.matches)timer=setTimeout(()=>{if(!item.contains(document.activeElement))close()},160)});
  button.addEventListener('click',()=>item.querySelector('.mega-menu').hidden?open(item):close());
  item.addEventListener('keydown',e=>{
   if(e.key==='Escape'){e.preventDefault();close();anchor.focus()}
   if(e.key==='ArrowDown'&&(e.target===anchor||e.target===button)){e.preventDefault();open(item);item.querySelector('.mega-menu a').focus()}
  });
 });
 mobile.onclick=()=>{const willOpen=!nav.classList.contains('open');close();setMobile(willOpen)};
 nav.addEventListener('click',e=>{if(e.target.closest('a'))closeMobile()});
 header.addEventListener('pointerenter',()=>clearTimeout(timer));
 header.addEventListener('pointerleave',()=>{if(desktop.matches)timer=setTimeout(close,160)});
 document.addEventListener('click',e=>{if(!header.contains(e.target))closeMobile()});
 document.addEventListener('focusin',e=>{if(!nav.contains(e.target))close()});
 nav.addEventListener('focusout',()=>setTimeout(()=>{if(!nav.contains(document.activeElement))close()},0));
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('open')){closeMobile();mobile.focus()}});
 document.addEventListener('keydown',e=>{
  if(e.key!=='Tab'||!nav.classList.contains('open'))return;
  const controls=[...header.querySelectorAll('a,button,input')].filter(el=>el.getClientRects().length&&!el.disabled);
  const first=controls[0],last=controls[controls.length-1];
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
 });
 desktop.addEventListener('change',closeMobile);
})();
